import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { leaderboardKeys } from '../leaderboard.keys';
import { getLeaderboardStats } from '../leaderboard.service';
export const useLeaderboardStats = (subdomain = getSubdomain(), sprintId, initialData, options) => {
    return useQuery({
        queryKey: leaderboardKeys.stats(subdomain, sprintId),
        queryFn: () => getLeaderboardStats(subdomain, sprintId),
        initialData,
        // Poll every 30 seconds to keep stats relatively fresh
        refetchInterval: 30000,
        // Keep data fresh for 5 minutes (matching backend cache)
        staleTime: 5 * 60 * 1000,
        retry: 1,
        ...options,
    });
};
